export const SUB_FB_PAGE = '/user/page/:fb_page_id'